import {
  TableRow,
  CustomCard,
  HeaderColumn,
  BootstrapTable,
  TableDetailCell,
  LastHeaderColumn,
  FirstHeaderColumn
} from "../common-styling";
import { Button, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NoResultsRow from "../no-results-table-row";
import { ListScroll } from "./fulfillment-kpi.styles";
import { LOAD_STATE } from "./fulfillment-kpi.helpers";

const headerFor = (index, count) => {
  if (index === 0) return FirstHeaderColumn;
  return index === count - 1 ? LastHeaderColumn : HeaderColumn;
};

// One list of the dashboard: title with the row count and a table that
// scrolls inside the card. `columns`: [{key, label, center}], `cells(row)`
// returns the cell content per column key. `rows` is the list, or
// LOAD_STATE.LOADING / LOAD_STATE.FAILED (then `onRetry` loads again).
const KpiListTable = ({ title, columns, rows, rowKey, cells, onRetry }) => {
  const { t } = useTranslation();
  const loaded = Array.isArray(rows);
  return (
    <CustomCard className="p-3 rounded-0">
      <h6 className="mb-3">
        {title}
        {loaded && ` (${rows.length})`}
      </h6>
      <ListScroll>
        <BootstrapTable responsive>
          <thead>
            <tr>
              {columns.map((column, index) => {
                const Header = headerFor(index, columns.length);
                return (
                  <Header
                    key={column.key}
                    className={column.center ? "text-center" : undefined}
                  >
                    {column.label}
                  </Header>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {!loaded ? (
              <TableRow>
                <TableDetailCell className="py-3" colSpan={columns.length}>
                  {rows === LOAD_STATE.FAILED ? (
                    <>
                      <span className="text-danger me-2">
                        {t("fulfillmentKpis.loadError")}
                      </span>
                      <Button variant="link" size="sm" onClick={onRetry}>
                        {t("fulfillmentKpis.retry")}
                      </Button>
                    </>
                  ) : (
                    <Spinner animation="border" size="sm" />
                  )}
                </TableDetailCell>
              </TableRow>
            ) : rows.length ? (
              rows.map((row) => {
                const content = cells(row);
                return (
                  <TableRow key={rowKey(row)}>
                    {columns.map((column) => (
                      <TableDetailCell
                        key={column.key}
                        className={`py-2${column.center ? " text-center" : ""}`}
                      >
                        {content[column.key]}
                      </TableDetailCell>
                    ))}
                  </TableRow>
                );
              })
            ) : (
              <NoResultsRow lengthOfColumns={columns.length} />
            )}
          </tbody>
        </BootstrapTable>
      </ListScroll>
    </CustomCard>
  );
};

export default KpiListTable;
